import React from "react";
import BootstrapSplitPane from "./splitpane";
import DocList from "./sidebar";
import { isMobile } from "../isMobile";
import Header from "./header";
import { Footer } from "./footer";

const localStorageMock = function () {
  let store = {};

  return {
    getItem: function (key) {
      return store[key];
    },
    setItem: function (key, value) {
      store[key] = value.toString();
    },
    clear: function () {
      store = {};
    },
    removeItem: function (key) {
      delete store[key];
    },
  };
};

const storage = () => {
  if (typeof localStorage != "undefined") {
    return localStorage;
  } else {
    return localStorageMock();
  }
};

const Layout = ({ children, location }) => {
  const [state, setState] = React.useState({showSideBar: false});

  let localStorageKey = typeof localStorage != "undefined" ? `explorer-grid-split-docs` : null;

  return (
      <>
        <Header location={location} />
        <BootstrapSplitPane
          collapsed={getCollapsedState(localStorageKey)}
          localStorageKey={localStorageKey}
          allowZero={true}
          defaultColSize={isMobile()? 0: 3}
          pane2ClassName={"min-vh-100 mb-5"}
          pane1ClassName={"page-sidebar min-vh-100"}
          onCollapseHook={() => {
            setState({ ...state, showSideBar: false });
            storage().setItem(`${localStorageKey}_show`, "false");
          }}
          onExpandHook={() => {
            setState({ ...state, showSideBar: true });
            storage().setItem(`${localStorageKey}_show`, "true");
          }}
          onDragFinished={(draggedSize) => {
            setState({ ...state, draggedSize });
          }}
          pane1Style={{
            borderRight: "1px solid grey",
            minHeight: "800px"
          }}
          pane2Style={{
            margin: 0,
            padding: 0
          }}
        >
          <DocList />
          <div className="container" style={{ fontFamily: "Roboto" }}>
            {children}
          </div>
        </BootstrapSplitPane>
        <Footer />
    </>
  );
};

export default Layout;


const getCollapsedState = (localStorageKey) => {
  if (storage().getItem(`${localStorageKey}_show`) === null)
  {
    return isMobile();
  }
  return storage().getItem(`${localStorageKey}_show`) === "false";

}